import { createFileRoute } from "@tanstack/react-router";

import RouteLabelsSettings from "@/components/RouteLabels/RouteLabelsSettings";

export const Route = createFileRoute("/gym/$venueUuid/settings/labels/")({
  component: RouteLabelsSettings,
});
